import { render } from "./Menu.vue?vue&type=template&id=2d3358ff"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Menu.vue?vue&type=style&index=0&id=2d3358ff&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script